import React from 'react';
import { Icon } from '@iconify/react';
import { useState,useEffect } from 'react';
import axios from 'axios';
import { jwtDecode } from "jwt-decode";



const UnitCountOne = () => {
    const BaseUrl = process.env.REACT_APP_API;
    const [totalInvestment, setTotalInvestment] = useState(0);
    const [totalCurrentValue, setTotalCurrentValue] = useState(0);
    const [percentageChange, setTotalPecentagechange] = useState(0);

    const [email, setEmail] = useState(null);
      
      
        const nameDecodeToken = (token) => {
          try {
            const decoded = jwtDecode(token);
            return decoded.email || null;
          } catch (error) {
            console.error("Invalid token:", error);
            return null;
          }
        };
        
          useEffect(() => {
                const token = sessionStorage.getItem("authToken");
                const email = nameDecodeToken(token);
                setEmail(email);
            if (token) {
              validateToken(token); 
            } 
          }, []);
      
            const validateToken = async (token) => {
            try {
      
              const baseUrl = process.env.REACT_APP_API;
          
              if (!baseUrl) {
                throw new Error("Base API URL is not defined in the environment file!");
              }
          
              const apiUrl = `${baseUrl}/validate-token`;
          
              const response = await fetch(apiUrl, {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({ token }),
              });
          
              if (!response.ok) {
                throw new Error("Token validation request failed!");
              }
          
              const data = await response.json();
          
              if (data.valid) {
               
              } else {
                throw new Error(data.message || "Token validation failed.");
              }
            } catch (error) {
              console.error("Token validation failed:", error.message);
            }
          }

    
    const jwtToken = sessionStorage.getItem("authToken");

    // Fetch data from the backend API
    useEffect(() => {
      const fetchInvestmentData = async () => {
        try {
          const response = await axios.get(
            `${BaseUrl}/corporate/nav`, 
            { 
              params: { token: jwtToken, email: email }, 
            }
          );
          const data = response.data;
          setTotalInvestment(data.totalInvestment);
          setTotalCurrentValue(data.totalCurrentValue);
          setTotalPecentagechange(data.percentageChange);
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      };
    
      fetchInvestmentData();
    }, [jwtToken]);  
      
    return (
        <div className="overflow-hidden">
            {/* Marquee Section */}
            {/* <marquee scrollamount="8" direction="left">
                <div className="d-flex gap-5 align-items-center">
                    <div className="d-flex align-items-center gap-3 text-nowrap">
                        <Icon icon="gridicons:multiple-users" className="text-primary text-2xl" />
                        <p className="mb-0 fw-medium text-primary">Nifty 50</p>
                        <h6 className="mb-0 fw-bold">23726.85</h6>
                        <span className="text-success d-flex align-items-center gap-1">
                            <Icon icon="bxs:up-arrow" className="text-xs" /> 112.90 (0.49%)
                        </span>
                    </div>

                    <div className="d-flex align-items-center gap-3 text-nowrap">
                        <Icon icon="fa-solid:award" className="text-primary text-2xl" />
                        <p className="mb-0 fw-medium text-primary">SENSEX</p>
                        <h6 className="mb-0 fw-bold">78200.61</h6>
                        <span className="text-danger d-flex align-items-center gap-1">
                            <Icon icon="bxs:down-arrow" className="text-xs" /> 237.87 (0.31%)
                        </span>
                    </div>

                    <div className="d-flex align-items-center gap-3 text-nowrap">
                        <Icon icon="fluent:people-20-filled" className="text-primary text-2xl" />
                        <p className="mb-0 fw-medium text-primary">GIFT NIFTY</p>
                        <h6 className="mb-0 fw-bold">23813</h6>
                        <span className="text-success d-flex align-items-center gap-1">
                            <Icon icon="bxs:up-arrow" className="text-xs" /> 72.00 (0.30%)
                        </span>
                    </div>

                    <div className="d-flex align-items-center gap-3 text-nowrap">
                        <Icon icon="solar:wallet-bold" className="text-primary text-2xl" />
                        <p className="mb-0 fw-medium text-primary">Gold</p>
                        <h6 className="mb-0 fw-bold">42000</h6>
                        <span className="text-success d-flex align-items-center gap-1">
                            <Icon icon="bxs:up-arrow" className="text-xs" /> 20,000
                        </span>
                    </div>
                </div>
            </marquee> */}

            <div className="row mt-4">
                <div className="col-md-6 ">
                    <div className="card shadow-none border bg-gradient-start-3 h-100">
                        <div className="card-body p-20">
                            <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                                <div>
                                    <p className="fw-medium text-primary-light mb-1">Value Invested</p>
                                    <h6 className="mb-0">${totalInvestment.toFixed(2)}</h6>
                                </div>
                                <div className="w-50-px h-50-px bg-blue rounded-circle d-flex justify-content-center align-items-center">
                                    <Icon
                                        icon="fa6-solid:file-invoice-dollar"
                                        className="text-white text-2xl mb-0"
                                    />
                                </div>
                            </div>
                            {/* <p className="fw-medium text-sm text-primary-light mt-12 mb-0 d-flex align-items-center gap-2">
                                <span className="d-inline-flex align-items-center gap-1 text-success-main">
                                    <Icon icon="bxs:up-arrow" className="text-xs" /> 0
                                </span>
                                
                            </p> */}
                        </div>
                    </div>
                </div>

                <div className="col-md-6 ">
                    <div className="card shadow-none border bg-gradient-start-3 h-100">
                        <div className="card-body p-20">
                            <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                                <div>
                                    <p className="fw-medium text-primary-light mb-1">Current Value</p>
                                    <h6 className="mb-0">${totalCurrentValue.toFixed(2)}</h6>
                                </div>
                                <div className="w-50-px h-50-px bg-blue rounded-circle d-flex justify-content-center align-items-center">
                                    <Icon
                                        icon="fa6-solid:file-invoice-dollar"
                                        className="text-white text-2xl mb-0"
                                    />
                                </div>
                            </div>
                            <p className="fw-medium text-sm text-primary-light mt-12 mb-0 d-flex align-items-center gap-2">
                            <span className={`d-inline-flex align-items-center gap-1 ${percentageChange >= 0 ? 'text-success-main' : 'text-danger-main'}`}>
                                <Icon 
                                icon={percentageChange >= 0 ? "bxs:up-arrow" : "bxs:down-arrow"} 
                                className="text-xs" 
                                />
                                {percentageChange}%
                            </span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UnitCountOne;
